// extracted by mini-css-extract-plugin
export var container = "_jg-0";
export var outlet = "_jg-1";
export var outletEnter = "_jg-2";
export var outletEnterActive = "_jg-3";
export var outletExit = "_jg-4";
export var outletExitActive = "_jg-5";